import React from 'react';
import { AddFolderIcon, LockOutlinedIcon, MoveFolderIcon, RemoveFolderIcon } from './styles';
export default function ModalIcon({
  type
}) {
  return {
    add: <AddFolderIcon data-testid="add-doc" />,
    lock: <LockOutlinedIcon />,
    move: <MoveFolderIcon />,
    remove: <RemoveFolderIcon />
  }[type];
}